import React from "react";
import logo from "../../gallery/logo.png";
import instagram from "../../gallery/icons/instagram-grey.png";
import facebook from "../../gallery/icons/fb-grey.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function Footer() {
  let settings = useSelector((state) => state.companySetting.settings);

  function goToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  return (
    <>
      <footer className="footer-bottom">
        <div className="container">
          <div className="d-flex flex-column flex-lg-row justify-content-between mb-4">
            <div className="d-flex align-items-center justify-content-center justify-content-lg-start mb-4 mb-lg-0">
              <Link onClick={goToTop} to="/">
                <img src={logo} alt={"Sahi Search"} className="footer-brand" />
              </Link>
            </div>
            <div className="d-flex justify-content-center align-items-center mb-5 mb-lg-0">
              <ul className="nav justify-content-center align-content-center flex-column flex-lg-row">
                <li className="nav-item text-center mb-3 mb-lg-0">
                  <Link to="/about" className="footer-link px-3">
                    About Us
                  </Link>
                </li>
                <li className="nav-item text-center mb-3 mb-lg-0">
                  <Link to="/privacy" className="footer-link px-3">
                    Privacy Policy
                  </Link>
                </li>
                <li className="nav-item text-center mb-3 mb-lg-0">
                  <Link to="/terms" className="footer-link px-3">
                    Terms & Conditions
                  </Link>
                </li>
              </ul>
            </div>
            <div className="text-end d-flex justify-content-center align-items-center flex-column mb-5 mb-lg-0">
              <p className="footer-copy-right">
                ©&nbsp;<span id="currentYear">2025</span> Sahi Search
              </p>
              <a href="https://www.cnblink.com/" target="blank" className="footer-copy-right">
                A product of CNBLINK
              </a>
            </div>
          </div>
          <div className="row">
            <section className="col-lg-12 col-lg-12 col-12 d-flex justify-content-center align-items-center">
              <ul className="nav justify-content-center">
                <li className="nav-item">
                  <a onClick={goToTop} href={settings ? settings.instagram_link : "https://www.instagram.com/sahisearch"} target="_blank" rel="noopener noreferrer" className="footer-link me-3">
                    <img src={instagram} alt={"Instagram"} className="footer-social" />
                  </a>
                </li>
                <li className="nav-item">
                  <a onClick={goToTop} href={settings ? settings.facebook_link : "https://www.facebook.com/sahisearch"} target="_blank" rel="noopener noreferrer" className="footer-link ms-2">
                    <img src={facebook} alt={"facebook"} className="footer-social" />
                  </a>
                </li>
              </ul>
            </section>
          </div>
        </div>
      </footer>
    </>
  );
}
export default Footer;
